const state = {
  noticeList: []
}

const getters = {

}

const mutations = {
}

const actions = {
  index ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/catalog/index', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
